


































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Switcher from '@/components/Switcher.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { PermissionsModule } from '@/store/modules/permissions.module'
import { getModule } from 'vuex-module-decorators'
import { FacilityModule } from '@/store/modules/facility.module'
import { UserModule } from '@/store/modules/user.module'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import Editable from '@/components/inputsV2/Editable.vue'
import {
  EPaymentEmailSettings,
  ESortOrder,
  EUserPermissions, EUserStatus,
  EUserType,
  IChain,
  IFacility,
  IUser,
  IUserChainRole,
  IUserCustomPermission,
  IUserDTO,
  IUserRolePermission
} from '@zunta/configurations'
import { email, minLength, required, requiredIf } from 'vuelidate/lib/validators'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { PHONE_MASK, TIMEZOMES_LIST, USER_PERMISSIONS_LIST } from '@/constants'
import { EUserPermissionsCategory, ITimeZoneListItem, IUserPermissionItem } from '@/interfaces'
import Icon from '@/components/Icon.vue'
import PermissionsModal from '@/views/app/management/users/components/PermissionsModal.vue'
import ScrollView from '@/components/ScrollView.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import FacilitiesAccessModal from '@/views/app/management/users/components/FacilitiesAccessModal.vue'
import MultiSelectV2 from '@/components/inputsV2/MultiSelectV2.vue'
import { getSelectContentLabel } from '@/utils/helpers'
import EmailFacilitiesModal from '@/views/app/management/users/components/EmailFacilitiesModal.vue'
import GoBack from '@/components/GoBack.vue'
import { ChainModule } from '@/store/modules/chain.module'
import DisableUserModal from '@/views/app/management/settings/components/DisableUserModal.vue'

@Component({
  components: {
    DisableUserModal,
    GoBack,
    EmailFacilitiesModal,
    MultiSelectV2,
    FacilitiesAccessModal,
    LoaderWrapper,
    Checkbox,
    ScrollView,
    PermissionsModal,
    Icon,
    SelectV2,
    InputV2,
    Editable,
    InputValidator,
    Switcher,
    Card
  }
})
export default class UserV2 extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  user: User = Api.getUser() as User
  getSelectContentLabel: Function = getSelectContentLabel
  PHONE_MASK = PHONE_MASK

  userData: Partial<IUserDTO> = {
    lastName: '',
    firstName: '',
    email: '',
    phone: '',
    phoneExtension: '',
    type: EUserType.CLIENT,
    isCustomPermissions: false,
    timezone: undefined,
    facilities: [],
    isAllFacilities: false,
    permissions: [],
    receiveManagerEmail: false,
    includePaymentsProcessedUser: false,
    includePaymentsProcessedManager: false,
    managerEmailFacilities: [],
    managerEmailFacilitiesAll: false,
    paymentEmailSetting: EPaymentEmailSettings.NEVER,
    depositEmail: false,
    managerEmailUsers: [],
    role: undefined,
    morningBriefing: undefined,
    afternoonBriefing: undefined,
    eveningBriefing: undefined
  }

  showFacilitiesModal: boolean = false
  showEmailFacilitiesModal: boolean = false
  showPermissionsModal: boolean = false
  showAllFacilities: boolean = false
  showAllEmailFacilities: boolean = false
  isLoading: boolean = false
  openedSections: string = EUserPermissionsCategory.FACILITY

  showReassignModal: boolean = false

  validations (): any {
    return {
      userData: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        email: {
          required,
          email
        },
        role: {
          required
        },
        phone: {
          required,
          phone: (val: any) => /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(val)
        },
        timezone: {
          required
        },
        facilities: {
          required: requiredIf(() => !this.userData.isAllFacilities),
          minLength: minLength(1) || this.userData.isAllFacilities
        },
        managerEmailFacilities: {
          required: requiredIf(() => this.userData.receiveManagerEmail && !this.userData.managerEmailFacilitiesAll),
          minLength: minLength(1) || this.userData.managerEmailFacilitiesAll
        },
        morningBriefing: {
          required: requiredIf(() => (!!this.userData.receiveManagerEmail || !!this.userData.includePaymentsProcessedUser) && !this.userData.afternoonBriefing && !this.userData.eveningBriefing)
        },
        afternoonBriefing: {
          required: requiredIf(() => (!!this.userData.receiveManagerEmail || !!this.userData.includePaymentsProcessedUser) && !this.userData.morningBriefing && !this.userData.eveningBriefing)
        },
        eveningBriefing: {
          required: requiredIf(() => (!!this.userData.receiveManagerEmail || !!this.userData.includePaymentsProcessedUser) && !this.userData.morningBriefing && !this.userData.afternoonBriefing)
        }
        // title: {
        //   required
        // }
      }
    }
  }

  get userId () {
    return this.$route.params.userId
  }

  get selectedUser () {
    return this.$store.state.user.selectedUser
  }

  get isNew () {
    return this.userId === 'new'
  }

  get userRoles () {
    return this.$store.state.permissions.roles || []
  }

  get permissionsCategories () {
    return Object.values(EUserPermissionsCategory)
  }

  get permissionsItemsList () {
    return USER_PERMISSIONS_LIST
      .filter((permissionItem: IUserPermissionItem) =>
        !!this.selectedRolePermissions
          .find((permission: IUserRolePermission) => permission.permission === permissionItem.permission)
      )
  }

  get permissionsByCategory () {
    return (cat: string) =>
      this.permissionsItemsList.filter((item: IUserPermissionItem) => cat === item.category)
  }

  get paymentEmailOptions () {
    return [
      {
        key: EPaymentEmailSettings.ALL_PAYMENTS,
        value: EPaymentEmailSettings.ALL_PAYMENTS,
        content: 'Yes'
      },
      {
        key: EPaymentEmailSettings.NEVER,
        value: EPaymentEmailSettings.NEVER,
        content: 'No'
      },
      {
        key: EPaymentEmailSettings.ONLY_RESIDENT_PORTAL_PAYMENTS,
        value: EPaymentEmailSettings.ONLY_RESIDENT_PORTAL_PAYMENTS,
        content: 'Only resident portal payments'
      }
    ]
  }

  get shownFacilities () {
    if (!this.userData.facilities || !this.userData.facilities.length) {
      return []
    }

    if (!this.showAllFacilities) {
      return this.userData.facilities.slice(0, 5)
    }

    return this.userData.facilities
  }

  get shownEmailFacilities () {
    if (!this.userData.managerEmailFacilities || !this.userData.managerEmailFacilities.length) {
      return []
    }

    if (!this.showAllEmailFacilities) {
      return this.userData.managerEmailFacilities.slice(0, 5)
    }

    return this.userData.managerEmailFacilities
  }

  getSelectedPermissionByCategory (cat: string) {
    if (this.userData.permissions && this.userData.permissions.length) {
      const permissions: EUserPermissions[] = this.userData.permissions
      return this.permissionsByCategory(cat)
        .filter((item: IUserPermissionItem) => permissions.includes(item.permission))
    }
    return []
  }

  get userRolesOptions () {
    return this.userRoles.map((userRole: IUserChainRole) => ({
      key: userRole.id,
      value: userRole.id,
      content: userRole.name
    }))
  }

  get timezoneOptions () {
    return TIMEZOMES_LIST.map((timezoneListItem: ITimeZoneListItem) => ({
      key: timezoneListItem.shortName,
      value: timezoneListItem.timezone,
      content: timezoneListItem.name
    }))
  }

  get afternoonBriefingListItems () {
    return [{
      key: '12:00 PM',
      content: '12:00 PM',
      value: 12
    }, {
      key: '12:30 PM',
      content: '12:30 PM',
      value: 12.5
    }, {
      key: '1:00 PM',
      content: '1:00 PM',
      value: 13
    }, {
      key: '1:30 PM',
      content: '1:30 PM',
      value: 13.5
    }, {
      key: '2:00 PM',
      content: '2:00 PM',
      value: 14
    }, {
      key: '2:30 PM',
      content: '2:30 PM',
      value: 14.5
    }, {
      key: '3:00 PM',
      content: '3:00 PM',
      value: 15
    }, {
      key: '3:30 PM',
      content: '3:30 PM',
      value: 15.5
    }, {
      key: 'donotsend',
      content: 'Do Not Send',
      value: null
    }]
  }

  get eveningBriefingListItems () {
    return [{
      key: '5:00 PM',
      content: '5:00 PM',
      value: 17
    }, {
      key: '5:30 PM',
      content: '5:30 PM',
      value: 17.5
    }, {
      key: '6:00 PM',
      content: '6:00 PM',
      value: 18
    }, {
      key: '6:30 PM',
      content: '6:30 PM',
      value: 18.5
    }, {
      key: '7:00 PM',
      content: '7:00 PM',
      value: 19
    }, {
      key: '7:30 PM',
      content: '7:30 PM',
      value: 19.5
    }, {
      key: 'donotsend',
      content: 'Do Not Send',
      value: null
    }]
  }

  get morningBriefingListItems () {
    return [{
      key: '5:00 AM',
      content: '5:00 AM',
      value: 5
    }, {
      key: '5:30 AM',
      content: '5:30 AM',
      value: 5.5
    }, {
      key: '6:00 AM',
      content: '6:00 AM',
      value: 6
    }, {
      key: '6:30 AM',
      content: '6:30 AM',
      value: 6.5
    }, {
      key: '7:00 AM',
      content: '7:00 AM',
      value: 7
    }, {
      key: '7:30 AM',
      content: '7:30 AM',
      value: 7.5
    }, {
      key: '8:00 AM',
      content: '8:00 AM',
      value: 8
    }, {
      key: '8:30 AM',
      content: '8:30 AM',
      value: 8.5
    }, {
      key: '9:00 AM',
      content: '9:00 AM',
      value: 9
    }, {
      key: '9:30 AM',
      content: '9:30 AM',
      value: 9.5
    }, {
      key: '10:00 AM',
      content: '10:00 AM',
      value: 10
    }, {
      key: 'donotsend',
      content: 'Do Not Send',
      value: null
    }]
  }

  get userList () {
    return this.$store.state.user.users
  }

  get chainId () {
    return (this.chainModuleInstance.getChain || {} as IChain).id as number
  }

  get usersListOptions () {
    return this.userList
      .filter((user: IUser) => user.status === EUserStatus.ACTIVE)
      .map((user: IUser) => ({
        key: user.id,
        value: user.id,
        content: `${user.firstName || ''} ${user.lastName || ''}`
      }))
  }

  get selectedRole () {
    const role = this.userRolesOptions.find((userRole: any) => this.userData.role === userRole.value)
    if (!role) {
      return ''
    }
    return role.content
  }

  get userCustomPermissionsList () {
    return this.$store.state.permissions.userCustomPermissions
  }

  get permissionsList () {
    return this.$store.state.permissions.permissions
  }

  get selectedRolePermissions () {
    return this.permissionsList.filter((permission: IUserRolePermission) => (
      permission.role === this.userData.role
    ))
  }

  get facilitiesList (): IFacility[] {
    return this.$store.state.facility.facilities || []
  }

  get facilitiesListOptions () {
    return this.facilitiesList.map((facility: IFacility) => ({
      key: facility.id,
      value: facility.id,
      content: facility.name
    }))
  }

  getFacilityLabel (facilityId: number) {
    const facility = this.facilitiesList.find((facility: IFacility) => Number(facility.id) === Number(facilityId))
    if (!facility) {
      return ''
    }

    return facility.name
  }

  async mounted () {
    try {
      this.isLoading = true
      if (!this.isNew) {
        await this.userModuleInstance.fetchUserById(this.userId)
      }

      await Promise.all([
        this.userModuleInstance.getManagementUsersList({
          chain: this.chainId,
          getUsersWithSamePermissions: true
        }),
        this.facilityModuleInstance.getFacilityList({
          chain: +this.chainId,
          sortBy: 'name',
          sortOrder: ESortOrder.ASC
        }),
        this.permissionsModuleInstance.getUserRoles(this.chainId),
        this.permissionsModuleInstance.getPermissions(this.chainId)
      ])

      if (!this.isNew) {
        await this.permissionsModuleInstance.getUserCustomPermissions(this.userId)

        this.userData = {
          ...this.selectedUser,
          role: this.selectedUser.role.id,
          facilities: (this.selectedUser.facilities || []).map(Number),
          managerEmailUsers: (this.selectedUser.managerEmailUsers || []).map(Number),
          managerEmailFacilities: (this.selectedUser.managerEmailFacilities || []).map(Number),
          permissions: this.userCustomPermissionsList.map((customPermission: IUserCustomPermission) => customPermission.permission),
          morningBriefing: this.selectedUser.morningBriefing ? Number(this.selectedUser.morningBriefing) : null,
          afternoonBriefing: this.selectedUser.afternoonBriefing ? Number(this.selectedUser.afternoonBriefing) : null,
          eveningBriefing: this.selectedUser.eveningBriefing ? Number(this.selectedUser.eveningBriefing) : null
        }
        this.$delete(this.userData, 'salt')
        this.$delete(this.userData, 'password')
      }
    } finally {
      this.isLoading = false
    }
  }

  toggleCategory (cat: string) {
    if (this.openedSections === cat) {
      this.openedSections = ''
      return
    }

    this.openedSections = ''
    setTimeout(() => (this.openedSections = cat), 300)
  }

  toggleAllPermissions (isAll: boolean) {
    this.userData.permissions = isAll
      ? this.selectedRolePermissions.map((permission: IUserRolePermission) => permission.permission)
      : []
  }

  disablePermission (permissionItem: IUserPermissionItem) {
    if (this.userData.permissions) {
      this.userData.permissions = this.userData.permissions.filter((permission: string) => permission !== permissionItem.permission)
      this.$v.$touch()
    }
  }

  removeFacility (facilityId: number) {
    if (this.userData.facilities && this.userData.facilities.length) {
      this.userData.facilities =
        this.userData.facilities.filter((facility: number) => facilityId !== facility)
      this.$v.$touch()
    }
  }

  removeEmailFacility (facilityId: number) {
    if (this.userData.managerEmailFacilities && this.userData.managerEmailFacilities.length) {
      this.userData.managerEmailFacilities =
        this.userData.managerEmailFacilities.filter((facility: number) => facilityId !== facility)
      this.$v.$touch()
    }
  }

  getRevokedFacilities (userDataDTO: Partial<IUserDTO>, previousUser: User) {
    if (!userDataDTO || !userDataDTO.chain) {
      return []
    }
    if (userDataDTO.isAllFacilities) {
      return []
    }
    const userFacilitiesDTO = userDataDTO.facilities || []
    const previousUserFacilities = previousUser.data.facilities || []
    const revokedFacilities = []
    for (const previousUserFacility of previousUserFacilities) {
      if (!userFacilitiesDTO.includes(previousUserFacility)) {
        revokedFacilities.push(previousUserFacility)
      }
    }
    return revokedFacilities
  }

  async save () {
    if (this.user.data.type !== 'ZUNTA' && !this.user.hasPermissionFor(EUserPermissions.MODIFY_USERS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Modify Users',
        message: 'Permission Denied',
        icon: 'warning'
      })
      return
    }

    this.$v.$touch()

    if (this.$v.$anyError) {
      const errorElements = document.getElementsByClassName('form-group error')
      this.$nextTick(() => {
        errorElements[0].scrollIntoView({ behavior: 'smooth', block: 'end' })
      })
      return
    }

    const revokedFacilities = this.getRevokedFacilities(this.userData, this.user)
    if (!this.isNew && !this.userData.isAllFacilities && revokedFacilities.length) {
      this.isLoading = true
      await this.userModuleInstance.checkUserAssignments({ userId: this.selectedUser.id, facilities: revokedFacilities })

      if (this.$store.state.user.userAssignments && this.$store.state.user.userAssignments.length) {
        this.showReassignModal = true
        this.isLoading = false
        return
      }

      try {
        this.isLoading = true
        if (!this.$store.state.user.userAssignments || !this.$store.state.user.userAssignments.length) {
          await this.saveUser()
          return
        }
      } finally {
        this.isLoading = false
      }
      return
    }

    await this.saveUser()
  }

  async saveUser () {
    try {
      this.isLoading = true

      if (!this.isNew) {
        await this.userModuleInstance.updateUser({
          id: this.selectedUser.id,
          data: {
            ...this.userData
          },
          type: 'management'
        })
        await this.userModuleInstance.getManagementUsersList({ chain: this.chainId })
        return
      }

      const res = await this.userModuleInstance.createUser({
        data: {
          ...this.userData,
          isChainAdmin: false
        },
        type: 'management'
      })

      await this.userModuleInstance.getManagementUsersList({ chain: this.chainId })

      if (res.error) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          header: `Can't Create User`,
          message: res.message ? res.message : `User wasn't created`,
          icon: 'warning'
        })
        return
      }

      if (res.id) {
        await this.$router.push({
          name: 'management-users-edit',
          params: { userId: res.id }
        })
      }
    } finally {
      this.isLoading = false
    }
  }
}
